import { Component, OnInit } from '@angular/core';
import {AssociateService} from '../../shared/services/associate.service'
import { Sort, PageEvent } from '@angular/material';
import * as io from 'socket.io-client';
import { Configuration } from '../../app.constants';
import { SocketService } from 'app/shared/services/socket.service';
@Component({
  selector: 'app-sent-email-list',
  templateUrl: './sent-email-list.component.html',
  styleUrls: ['./sent-email-list.component.css']
})
export class SentEmailListComponent implements OnInit {

  public users:any = [];
  public query:any;
  public search:any = "";
  public length = 0;
  public pageSize = 10;
  public pageSizeOptions = [5, 10, 25, 100];
  public socket:any;
  public serverApiUrl: any;
  constructor(public associateService:AssociateService,public config: Configuration,private socketService:SocketService) { }

  ngOnInit() {
    // this.socket = io(this.config.SocketUrl);
    this.serverApiUrl = this.config.StaticImageUrl;
    this.query = {
      search : {
          'fullName':{ $regex: '', $options: 'i' },
          // 'isWelcomeEmailsent':true,
          '$or':[
            {'signupAccount':{'$exists':true}},
            {'isWelcomeEmailsent':true}
          ],          
      },
      sort: { 'fullName': 1 },
      pagination: {
          pageIndex: 0,
          pageSize: this.pageSize
      }
    };

    // this.socket.on('user-updated',function(data){
    //   if(data){
    //     window.location.reload(true);
    //     this.getUsers();
    //   }
    // }.bind(this));

    this.getUsers();

    // this.socketListner();
  }

  socketListner(){
    this.socketService.userUpdateObs.subscribe(res=>{
      if(res){
        window.location.reload(true);
        this.getUsers();
      }

    });
  }

  getUsers(){
    this.query.search.fullName = { $regex: this.search, $options: 'i' },
    this.associateService.getWelcomeEmailGeneratedUsers(this.query).subscribe(data=>{
      console.log(data)
      this.users = Object.assign([],data['data']);
      // this.users.forEach(indUser => {
      //     console.log(indUser.profileReview, ' ==> ', indUser.fullName);
      // });
      this.length = data['length'];
    })
  }
  compareBools(a, b, isAsc) {
    return (a === false &&  b===true ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareInt(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    let isAsc = sort.direction === 'asc';
    // if(sort.active === 'lastDeviceLogin' || sort.active === 'email' || sort.active === 'fullName' || sort.active === 'signupAccount'){
    //     this.users.sort((a,b) => {
    //       return this.compareStrings(a[sort.active] ? a[sort.active].toLowerCase(): '', b[sort.active] ? b[sort.active].toLowerCase(): '', isAsc);
    //     });
    // } else if(sort.active === 'Functional' || sort.active === 'OpCo' || sort.active === 'Country' || 
    //           sort.active === 'SOA' || sort.active === 'Region' || sort.active === 'assessment' || 
    //           sort.active === 'profileReview' || sort.active === 'isSignUp'){
    //   this.users.sort((a,b) => {
    //     // return isAsc ? (a === b)? 0 : a? -1 : 1 : (a === b)? 0 : a? 1 : -1 ;
    //     return this.compareStrings(a[sort.active] ? a[sort.active].toLowerCase(): '', b[sort.active] ? b[sort.active].toLowerCase(): '', isAsc);
    //   });
    // } else if(sort.active === 'sentEmailTime' || sort.active === 'signupTime'){
    //     this.users.sort((a,b) => {
    //       // return this.compareDates(a,b,isAsc);
    //       return this.compareStrings(a[sort.active] ? a[sort.active].toLowerCase(): '', b[sort.active] ? b[sort.active].toLowerCase(): '', isAsc);
    //     });
    // }

    if(sort.active === 'Functional' || sort.active === 'OpCo' || sort.active === 'Country' || 
            sort.active === 'SOA' || sort.active === 'Region' || sort.active === 'assessment' || 
            sort.active === 'profileReview' || sort.active === 'isSignUp'){

    this.users.sort((a,b) => {
      // return isAsc ? (a === b)? 0 : a? -1 : 1 : (a === b)? 0 : a? 1 : -1 ;
      return this.compareBools(a[sort.active] ? a[sort.active]: false, b[sort.active] ? b[sort.active]: false, isAsc);
    });

  } else if(sort.active === 'profileValidated'){

    this.users.sort((a,b) => {
      // return isAsc ? (a === b)? 0 : a? -1 : 1 : (a === b)? 0 : a? 1 : -1 ;
      return this.compareInt(a[sort.active], b[sort.active], isAsc);
    });

  } else {
     this.query.sort = {};
    if (sort.direction === 'asc') {
        this.query.sort[sort.active] = -1;
    } else if (sort.direction === 'desc') {
        this.query.sort[sort.active] = 1;
    }
    this.getUsers();
  }



    // this.users.sort((a,b) => {
    //   if(sort.active === 'lastDeviceLogin' || sort.active === 'email' || sort.active === 'fullName' || sort.active === 'signupAccount'){
    //       return this.compareStrings(a[sort.active].toLowerCase(), b[sort.active].toLowerCase(), isAsc);
    //   } else if(sort.active === 'Functional' || sort.active === 'OpCo' || sort.active === 'Country' || 
    //             sort.active === 'SOA' || sort.active === 'Region' || sort.active === 'assessment' || 
    //             sort.active === 'profileReview' || sort.active === 'isSignUp'){
    //     return isAsc ? (a === b)? 0 : a? -1 : 1 : (a === b)? 0 : a? 1 : -1 ;
    //   } else if(sort.active === 'sentEmailTime' || sort.active === 'signupTime'){
    //       return this.compareDates(a,b,isAsc);
    //   }
    // });
    // return;
    
}


  // getServerData(event) {
  //   this.query.pagination.pageIndex = event.pageIndex;
  //   this.query.pagination.pageSize = event.pageSize;
  //   this.pageSize = event.pageSize;
  //   this.getUsers();  
  // }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }
}
